import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Form,
  Button,
  Input,
} from 'antd';


const CommentForm = ({ onSendMessage }) => {
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const [error, setError] = useState(null);

  useEffect(() => {
    forceUpdate({});
  }, []);

  const onSubmit = async (values) => {
    try {
      const comment = {
        content: values?.message || "",
      }
      onSendMessage(comment);
      form.resetFields();
      setError(null);
    } catch (e) {
      console.log("CommentForm error", e);
      setError(e);
    }
  };
  return (
    <div className="send-comment-form-container">
      <Row>
        <Col xs={24} className="form-wrapper">
          <Form layout="vertical" form={form} onFinish={onSubmit}>
            <Form.Item
              name="message"
              rules={[
                {
                  required: true,
                  message: "Debes ingresar un mensaje.",
                }
              ]}
            >
              <Input.TextArea
                size="large"
                placeholder="Envia un mensaje"
                autoSize={{ minRows: 2, maxRows: 3 }}
              />
            </Form.Item>
            <Form.Item shouldUpdate={true} style={{ margin: 0 }}>
              {() => (
                <Button
                  type="primary"
                  style={{ minWidth: 150, fontWeight: 'bold' }}
                  type="primary"
                  size="large"
                  htmlType="submit"
                  shape="round"
                  disabled={
                    form
                      .getFieldsError()
                      .filter(({ errors }) => errors.length).length
                  }
                >
                  Enviar
                </Button>
              )}
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  )
}

export default CommentForm;